import { createAsyncThunk } from "@reduxjs/toolkit";
import ReducerEntityPrefixTypes from "enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "enums/reducer/reducerNamespaceTypes";
import { type FetchActionPayload } from "interfaces";
import dataService from "features/Application/services/dataServices/typedDataService";
import { getPrefix } from "features/Application/slices/models";
import { type AvailablePacksRequest } from "features/Accounts/types";
import { type AccountAvailablePackOverview } from "features/Accounts/PackAssignmentModal/types";

const countHeaderName = process.env.REACT_APP_COUNT_HEADER_NAME as string;
const loadGridItemsCount: any = process.env.REACT_APP_LOAD_ITEMS_COUNT;

export const fetchAvailablePacks = createAsyncThunk<
  FetchActionPayload<AccountAvailablePackOverview>,
  AvailablePacksRequest
>(
  getPrefix({
    namespace: ReducerNamespaceTypes.Licensing,
    entity: ReducerEntityPrefixTypes.AvailablePacks,
    name: "availablePacks",
  }),
  async (requestData: AvailablePacksRequest, { signal }) => {
    const request = {
      top: loadGridItemsCount,
      skip: requestData.skip,
      orderBy: requestData.orderBy,
      searchTerm: requestData.searchTerm,
      showAdded: true,
    };

    const { getDataPromise, cancel } = dataService.accounts.getAvailablePacksWithCancel(
      requestData.assignedAccountId,
      request,
      requestData.filters || {},
    );

    signal.addEventListener("abort", cancel);

    const result = await getDataPromise;
    const recordsCount = Number.parseInt(result.headers[countHeaderName]);

    return {
      items: result.data,
      totalCount: recordsCount,
      append: requestData.allowAppend && requestData.skip > 0,
    };
  },
);
